import { Observable, Subject, Subscription } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { InterActions } from '@mode/shared/contract-common';

InterActions;

interface ChartActionMessage {
  componentId: string;
  action: InterActions.Union;
}

export class ReportApiService implements InterActions.Queue {
  private actions: Subject<ChartActionMessage>;

  constructor() {
    this.actions = new Subject<ChartActionMessage>();
  }

  dispatch(componentId: string, action: InterActions.Union): void {
    this.actions.next({ componentId, action });
  }

  makeObservable(targetId$: Observable<string>) {
    return this.actions.pipe(
      withLatestFrom(targetId$),
      filter(([{ componentId }, targetId]) => componentId.split('_')[1] === targetId),
      map(([msg, token]) => ({
        action: msg.action,
        chartToken: token,
      }))
    );
  }

  subscribe(targetComponentId: string, handler: InterActions.Handler): Subscription {
    return this.actions.subscribe(({ componentId, action }) => {
      try {
        if (componentId === targetComponentId) {
          handler(action);
        }
      } catch (err) {
        console.error(err);
      }
    });
  }
}
